import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.5 16L12 7.5L20.5 16", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChevronUp.js.map